import { animate, scroll, inView, stagger, ScrollOffset } from "motion"
import EmblaCarousel from "embla-carousel"
import Autoplay from "embla-carousel-autoplay"
import Lenis from "lenis"

// // SMOOTH SCROLL
// const lenis = new Lenis()

// lenis.on("scroll", (e) => {})

// function raf(time) {
// 	lenis.raf(time)
// 	requestAnimationFrame(raf)
// }

// requestAnimationFrame(raf)

// MOBILE NAV MUST BE ON TOP BECAUSE THE STUFF BELOW WON"T LOAD IN NON_HOME PAGES
const hamburgerButton = document.getElementById("open-mobile-nav-button")
const closeMobileNavButton = document.getElementById("close-mobile-nav-button")
const mobileNav = document.getElementById("mobile-nav")
const mobileNabLinks = document.querySelectorAll(".mobile-nav-link")
const pageBackBtn = document.getElementById("page-back-btn")

hamburgerButton?.addEventListener("click", () => {
	animate(mobileNav, { width: "300px" })
})

closeMobileNavButton?.addEventListener("click", () => {
	animate(mobileNav, { width: 0 })
})

mobileNabLinks?.forEach((link) => {
	link.addEventListener("click", () => {
		animate(mobileNav, { width: 0 })
	})
})

pageBackBtn?.addEventListener("click", (e) => {
	e.preventDefault()
	const previousLink = document.referrer
	if(previousLink.includes(window.location.origin)) {
		window.history.back();
	} else {
		window.location.href = pageBackBtn.getAttribute('href')
	}
})

// DESKTOP NAV ANIMATION
const desktopNavbarLogo = document.getElementById("desktop-navbar-logo")

const desktopNavTopSpacer = document.getElementById("desktop-nav-top-spacer")
const desktopNavBottomSpacer = document.getElementById(
	"desktop-nav-bottom-spacer"
)

inView(desktopNavTopSpacer, (info) => {
	if (screenWidth < 768) return
	desktopNavbarLogo?.setAttribute("src", logoPaths?.large)
	animate(
		info?.target,
		{
			height: "40px"
		},
		{ duration: 1.2 }
	)
	animate(
		desktopNavBottomSpacer,
		{
			height: "40px"
		},
		{ duration: 1.2 }
	)

	return ({ target }) => {
		desktopNavbarLogo?.setAttribute("src", logoPaths?.small)
		animate(
			target,
			{
				height: "20px"
			},
			{ duration: 1.5 }
		)

		animate(
			desktopNavBottomSpacer,
			{
				height: "20px"
			},
			{ duration: 1.5 }
		)
	}
})

// FOOTER CONTACT FORM MOBILE
const mobileContactFormModalOverlay = document.getElementById(
	"contact-form-modal-overlay"
)
const openMobileContactFormButton = document.getElementById(
	"open-contact-form-modal-button"
)
const closeMobileContactFormButton = document.getElementById(
	"close-contact-form-modal-button"
)
const documentBody = document.querySelector("body")

openMobileContactFormButton?.addEventListener("click", () => {
	openModal()
})

closeMobileContactFormButton?.addEventListener("click", () => {
	closeModal()
})

function openModal() {
	mobileContactFormModalOverlay.classList.remove("hidden")
	mobileContactFormModalOverlay.classList.add("grid")
	documentBody.classList.add("overflow-hidden")
}

function closeModal() {
	mobileContactFormModalOverlay.classList.add("hidden")
	mobileContactFormModalOverlay.classList.remove("grid")
	documentBody.classList.remove("overflow-hidden")
}

// IF ADD JS FOR NON-HOME PAGE PUT ABOVE
let screenWidth = window.innerWidth

addEventListener("resize", () => {
	screenWidth = window.innerWidth
})

// Load banner video if the video is not a link (youtube)
// ONLY ALLOW ONE VIDEO and IF THERE IS A VIDEO, THERE WILL BE NO IMAGE OR OTHER BANNERs
window.onload = () => {
	// const bannerVideo = document.getElementById("banner-video")
	// if (!bannerVideo) return

	// const bannerObjectVideoKey = Object.keys(banners)[0]
	// const bannerDetails = banners[bannerObjectVideoKey]
	// if (bannerDetails?.status !== "publish") return

	// if (screenWidth < 768) {
	// 	bannerVideo.src = bannerDetails?.["banner-video-mobile"]
	// } else {
	// 	bannerVideo.src = bannerDetails?.["banner-video"]
	// }
}

if(document.getElementById("scroll-section")) {
	// HORIZONTAL SCROLL SECTION
	scroll(
		animate("#scroll-section", {
			x: ["0%", screenWidth < 768 ? "-410vw" : "-270vw"]
		}),
		{
			target: document.getElementById("life-goal")
		}
	)
}

const horizontalScrollImages = document.querySelectorAll(
	".horizontal-scroll-image"
)
horizontalScrollImages?.forEach((image, index) => {
	if (screenWidth < 768) return
	inView(
		image,
		(info) => {
			animate(info.target.querySelector(".horizontal-scroll-image-overlay"), {
				opacity: 0
			})
			return (leaveInfo) => {
				animate(
					leaveInfo.target.querySelector(".horizontal-scroll-image-overlay"),
					{ opacity: 0.7 }
				)
			}
		},
		{ amount: screenWidth < 768 ? 0.5 : 0.8 }
	)
})

// INTRODUCTION SECTION
const introductionContentContainer = document.getElementById(
	"introduction-content-container"
)
const introductionTitle = document.getElementById("introduction-title")
const introductionContentLeft = document.getElementById(
	"introduction-content-left"
)
const introductionContentRight = document.getElementById(
	"introduction-content-right"
)

if(introductionTitle) {
	inView(introductionTitle, ({ target }) => {
		animate(
			target,
			{ opacity: 1, y: 0 },
			{ delay: 0.2, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
		)

		return ({ target }) => {
			animate(
				target,
				{ opacity: 0, y: "-50px" },
				{ duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
			)
		}
	})
}

if(introductionContentContainer) {
	inView(introductionContentContainer, ({ target }) => {
		animate(
			[introductionContentLeft, introductionContentRight],
			{ opacity: 1, transform: "none" },
			{
				delay: stagger(0.4, { start: 0.4 }),
				duration: 0.9,
				easing: [0.17, 0.55, 0.55, 1]
			}
		)

		return ({ target }) => {
			animate(
				[introductionContentLeft, introductionContentRight],
				{ opacity: 0, transform: "translateY(-50px)" },
				{ duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
			)
		}
	})
}

// VOCAB ANIMATION SECTION
const characterAnimationSectionTitle = document.getElementById(
	"character-animation-section-title"
)
const characterAnimationSectionChatbox = document.getElementById(
	"character-animation-section-chatbox"
)

const animatedCharacters = document.getElementById("animated-characters")

if(characterAnimationSectionTitle) {
	inView(characterAnimationSectionTitle, ({ target }) => {
		animate(
			target,
			{ opacity: 1, transform: "none" },
			{ delay: 0.2, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
		)
	})
	}

if(characterAnimationSectionChatbox) {
	inView(characterAnimationSectionChatbox, ({ target }) => {
		animate(
			target,
			{ opacity: 1, transform: "none" },
			{ delay: 0.4, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
		)
	})
}

if(animatedCharacters) {
	inView(animatedCharacters, ({ target }) => {
		animate(
			target,
			{ opacity: 1, transform: "none" },
			{ delay: 0.6, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
		)
	})
}

// VOCAB ANIMATION 中
const animatedCharactersDiv = document.getElementById("animated-characters")
const animatedCharactersDivBottom =
	animatedCharactersDiv?.getBoundingClientRect().bottom

const servicesSectionTitle = document.getElementById("services-section-title")
const servicesSectionTitleBottom =
	servicesSectionTitle?.getBoundingClientRect().bottom
const servicesSectionTitleLeft =
	servicesSectionTitle?.getBoundingClientRect().left

const engCentalineTitle = document.getElementById("services-centaline-position")
const engCentalineTitleBottom =
engCentalineTitle?.getBoundingClientRect().bottom
const engCentalineTitleLeft =
engCentalineTitle?.getBoundingClientRect().left


const jungCharacter = document.getElementById("jung-character")
const jungCharacterLeft = jungCharacter?.getBoundingClientRect().left

const yuenCharacter = document.getElementById("yuen-character")
const yuenCharacterLeft = yuenCharacter?.getBoundingClientRect().left

const jungCharIsEn = document.getElementsByClassName("jung_char_en")

// 中
if(jungCharacter) {
	if (jungCharIsEn.length == 0) {
		scroll(
			animate("#jung-character", {
				y: [
					0,
					screenWidth < 768
						? `${servicesSectionTitleBottom - animatedCharactersDivBottom - 2}px`
						: `${servicesSectionTitleBottom - animatedCharactersDivBottom - 15}px`
				],
				scale: [1, screenWidth < 768 ? 1.87 : 3.8],
				x: [
					0,
					screenWidth < 768
						? `${engCentalineTitleLeft - jungCharacterLeft - 6}px`
						// : `${servicesSectionTitleLeft - jungCharacterLeft / 2 + 150}px`
						: `${engCentalineTitleLeft - jungCharacterLeft }px`
				]
			}),
			{
				target: document.getElementById("character-animation-section"),
				offset: ["center 80dvh", "70% 70%"]
			}
		)
	} else {
		scroll(
			animate("#jung-character", {
				y: [
					0,
					screenWidth < 1280
						? `${engCentalineTitleBottom - animatedCharactersDivBottom - 6}px`
						: `${servicesSectionTitleBottom - animatedCharactersDivBottom - 16.5}px`
				],
				scale: [1, screenWidth < 1280 ? 2 : 3.8],
				x: [
					0,
					screenWidth < 1280
						? `${engCentalineTitleLeft - jungCharacterLeft + 24}px`
						: `${servicesSectionTitleLeft - jungCharacterLeft + 24}px`
				]
			}),
			{
				target: screenWidth >= 1280 ? document.getElementById("character-animation-section"):document.getElementById("services-centaline-position"),
				offset: ["center 80dvh", "70% 70%"]
			}
		)
	}

	// 願 -> 原
	if (jungCharIsEn.length == 0) {
		scroll(
			animate("#yuen-character", {
				y: [
					0,
					screenWidth < 768
						? `${servicesSectionTitleBottom - animatedCharactersDivBottom - 2}px`
						: `${servicesSectionTitleBottom - animatedCharactersDivBottom - 15}px`
				],
				scale: [1, screenWidth < 768 ? 1.87 : 3.8],
				x: [
					0,
					screenWidth < 768
						? `${engCentalineTitleLeft - yuenCharacterLeft + 20}px`
						: `${engCentalineTitleLeft - yuenCharacterLeft + 57}px`
				]
			}),
			{
				target: document.getElementById("character-animation-section"),
				offset: ["center 80dvh", "70% 70%"]
			}
		)
	} else {
		scroll(
			animate("#yuen-character", {
				y: [
					0,
					screenWidth < 1280
						? `${engCentalineTitleBottom - animatedCharactersDivBottom - 6}px`
						: `${servicesSectionTitleBottom - animatedCharactersDivBottom - 16.5}px`
				],
				scale: [1, screenWidth < 1280 ? 2 : 3.8],
				x: [
					0,
					screenWidth < 1280
						? `${engCentalineTitleLeft - yuenCharacterLeft + 94}px`
						: `${servicesSectionTitleLeft - yuenCharacterLeft + 147}px`
				]
			}),
			{
				target: screenWidth >= 1280 ? document.getElementById("character-animation-section"):document.getElementById("services-centaline-position"),
				offset: ["center 80dvh", "70% 70%"]
			}
		)
	}

	if (jungCharIsEn.length == 1) {
		scroll(
			({y}) => {
				const charChungEn = document.getElementById('jung-character')
				if (!charChungEn) return

				if (y && ((screenWidth < 1280 && y.progress > 0.68) || (screenWidth > 1280 && y.progress > 0.72))) {
					charChungEn.innerHTML = "Centa"
				} else {
					charChungEn.innerHTML = "Centre"
				}
			}
		)
	}

	scroll(
		({ y }) => {
			const charYuenSVG1 = document.getElementById('char_yuen_1')
		const charYuenSVG2 = document.getElementById('char_yuen_2')

			if (!charYuenSVG1 || !charYuenSVG2) return

		if (y && y.progress > 0.25) {
			charYuenSVG1.style.display = 'none'
			charYuenSVG2.style.display = 'block'
		} else {
			charYuenSVG1.style.display = 'block'
			charYuenSVG2.style.display = 'none'
		}
		},
		{
			target: document.getElementById("character-animation-section"),
			offset: ["center 80vh", "70% 70%"]
		}
	)
}

// FINANCIAL SERVICE SECTION
const financialServiceListContainer = document.getElementById(
	"financial-service-list-container"
)

if(financialServiceListContainer) {
	inView(financialServiceListContainer, ({ target }) => {
		animate(
			target,
			{ opacity: 1, transform: "none" },
			{ delay: 0.6, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
		)

		return ({ target }) => {
			animate(
				target,
				{ opacity: 0, transform: "translateY(50px)" },
				{ duration: 0.1, easing: [0.17, 0.55, 0.55, 1] }
			)
		}
	})
}

const serviceSection = document.getElementById("services-section")
if(serviceSection) {
	const serviceSectionAccordions = serviceSection.querySelectorAll(".accordion")

	if(serviceSectionAccordions.length > 0) {
		serviceSectionAccordions?.forEach((accordion) => {
			accordion?.addEventListener("click", () => {
				// Close all other accordions
				serviceSectionAccordions.forEach((otherAccordion) => {
					if (
						otherAccordion !== accordion &&
						otherAccordion.getAttribute("aria-expanded") === "true"
					) {
						otherAccordion.setAttribute("aria-expanded", "false")
					}
				})

				// Toggle the clicked accordion
				if (accordion.getAttribute("aria-expanded") === "true") {
					accordion.setAttribute("aria-expanded", "false")
				} else {
					accordion.setAttribute("aria-expanded", "true")
				}
			})
		})
	}
}

// CENTASEC INFO SECTION
const infoSectionImageContainer = document.getElementById(
	"jung-yuen-section-image-container"
)
const centasecInfoSection = document.getElementById("centasec-info-section")

if(centasecInfoSection) {
	scroll(animate(infoSectionImageContainer, { y: ["-7vh", "7vh"] }), {
		target: centasecInfoSection,
		offset: ["center 80vh", "70% 70%"]
	})
	// CENTASEC INFO SECTION ACCORDIONS
	const centasecInfoSectionAccordions =
		centasecInfoSection.querySelectorAll(".accordion")

	if(centasecInfoSectionAccordions.length > 0) {
		centasecInfoSectionAccordions?.forEach((accordion) => {
			accordion?.addEventListener("click", () => {
				// Close all other accordions
				centasecInfoSectionAccordions.forEach((otherAccordion) => {
					if (
						otherAccordion !== accordion &&
						otherAccordion.getAttribute("aria-expanded") === "true"
					) {
						otherAccordion.setAttribute("aria-expanded", "false")
					}
				})

				// Toggle the clicked accordion
				if (accordion.getAttribute("aria-expanded") === "true") {
					accordion.setAttribute("aria-expanded", "false")
				} else {
					accordion.setAttribute("aria-expanded", "true")
				}
			})
		})
	}
}


// EMBLA CAROUSEL
const OPTIONS = { loop: true }

const emblaNode = document.querySelector(".embla")
if(emblaNode) {
	const viewportNode = emblaNode.querySelector(".embla__viewport")

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
		Autoplay({ playOnInit: false, delay: 4000 })
	])
	emblaApi?.plugins()?.autoplay?.play()
}



// WECHAT MODAL

const wechatDialog = document.getElementById("wechat-dialog")
const showWeChatDialogButton = document.getElementById("wechat-button")
const closeWeChatDialogButton = document.getElementById("close-wechat-dialog-button")

showWeChatDialogButton.addEventListener("click", () => {
	document.querySelector("body").style.overflow = "hidden"
	wechatDialog.showModal()
})

closeWeChatDialogButton.addEventListener("click", () => {
	document.querySelector("body").style.overflow = "auto"
	wechatDialog.close()
})
